import { Observable } from 'rxjs/internal/Observable';
import { APIService } from '@app/_services/api.service';
import { API_PATH } from '@app/app.constants';
import { ResponseStudentClass, ResponseStudent, ResponseMain, ResponseStudents } from '@app/_interfaces/responses';

export class PeopleService {
    constructor(private api: APIService) {}

    getSchools(): Observable<any> {
        return this.api.get(API_PATH.main.schools);
    }

    getSchoolClasses(schoolId: number): Observable<any> {
        const url = `people/schools/${schoolId}/classes/`;
        return this.api.get(url);
    }

    getClasses(): Observable<any> {
        return this.api.get(API_PATH.people.classes);
    }

    getClass(studentClassId: number): Observable<any> {
        const url = `${API_PATH.people.classes}${studentClassId}/`;
        return this.api.get(url);
    }

    getStudents(studentClassId: number): Observable<any> {
        const url = `people/classes/${studentClassId}/students/`;
        return this.api.get(url);
    }

    getCurrentUserClasses(): Observable<ResponseStudentClass> {
        return this.api.get(API_PATH.people.current_user_classes);
    }

    updatePassword(formData): Observable<any> {
        return this.api.post(API_PATH.people.update_password, formData);
    }

    getCurrentStudent(): Observable<ResponseStudent> {
        return this.api.get(API_PATH.people.current_student);
    }

    getUserPhoto(groupName: string): Observable<ResponseMain> {
        const url = `${API_PATH.people.user_photo}/${groupName}`;
        return this.api.get(url);
    }

    getParentChildren(userId: number): Observable<ResponseStudents> {
        const url = `${API_PATH.people.parent_children}/${userId}/`;
        return this.api.get(url);
    }

    getProfileSchools(): Observable<any> {
        return this.api.get(API_PATH.people.profile_schools);
    }
}
